import { createContext } from 'react';

import Loader from '../components/UI/loader/Loader';

import {
  useGetAuthenticationQuery,
  useGetAuthTokenQuery,
} from '../services/ADapi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { data: authData, isLoading } = useGetAuthenticationQuery();
  const { data: planFeatures = {}, isLoading: isTokenLoading } =
    useGetAuthTokenQuery();

  const { username, is_authenticated } = authData || {};

  if (isLoading || isTokenLoading) {
    return <Loader />;
  }

  return (
    <AuthContext.Provider
      value={{
        planFeatures,
        username,
        is_authenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
